import { Search, X } from "lucide-react";
import { useId, type FormEvent, type ReactNode } from "react";
import { Button } from "./Button";
import { Input } from "./FormControls";
import { cn } from "./cn";

export interface FilterBarProps {
  search?: string;
  onSearchChange?: (value: string) => void;
  onSubmit?: () => void;
  searchPlaceholder?: string;
  searchLabel?: string;
  children?: ReactNode;
  hasActiveFilters?: boolean;
  onClear?: () => void;
  className?: string;
}

export function FilterBar({
  search,
  onSearchChange,
  onSubmit,
  searchPlaceholder = "Pesquisar…",
  searchLabel = "Pesquisar",
  children,
  hasActiveFilters = false,
  onClear,
  className
}: FilterBarProps) {
  const searchId = useId();

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    onSubmit?.();
  }

  return (
    <form
      role="search"
      onSubmit={submit}
      className={cn(
        "flex flex-col gap-3 rounded-lg border bg-card p-4 sm:flex-row sm:flex-wrap sm:items-end",
        className
      )}
    >
      {onSearchChange ? (
        <div className="min-w-0 flex-1 sm:min-w-64">
          <label htmlFor={searchId} className="sr-only">
            {searchLabel}
          </label>
          <div className="relative">
            <Search
              className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-zinc-400"
              aria-hidden="true"
            />
            <Input
              id={searchId}
              type="search"
              value={search ?? ""}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder={searchPlaceholder}
              className="pl-9"
            />
          </div>
        </div>
      ) : null}
      {children}
      {onSubmit ? <Button type="submit">Aplicar filtros</Button> : null}
      {hasActiveFilters && onClear ? (
        <Button variant="ghost" onClick={onClear}>
          <X className="size-4" aria-hidden="true" />
          Limpar
        </Button>
      ) : null}
    </form>
  );
}
